// Indian Rupee formatter (₹1,23,456.00)
const inrFmt = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export function inr(v) {
  const n = Number(v ?? 0);
  if (Number.isNaN(n)) return "₹0.00";
  return inrFmt.format(n);
}

// Local-date components, never toISOString() (UTC) — the system is pinned to Asia/Kolkata (+05:30), so a
// UTC-based date is wrong for five and a half hours after every local midnight (wave review, Important #6).
function localIso(d) {
  const pad = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function todayIso() {
  // server is source of truth for "today"; this is for UI defaults only
  return localIso(new Date());
}

/** "today" / "week" (the last 7 days, inclusive of today) / "month" (the 1st of this month to today) /
 *  "fy" (1 April to today) → [from, to], all in local time via todayIso()/localIso() — never
 *  toISOString(). Shared by PettyCashReport and AccountsJournal so the same UTC-vs-local bug (an empty
 *  "Today" between midnight and 05:30 IST, a from > to "This Month" on the 1st) cannot be reintroduced
 *  independently in either page, or in a future one. */
export function quickRange(kind) {
  const now = new Date();
  if (kind === "today") return [todayIso(), todayIso()];
  if (kind === "week") {
    const d = new Date(now);
    d.setDate(d.getDate() - 6);
    return [localIso(d), todayIso()];
  }
  if (kind === "month") return [`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`, todayIso()];
  if (kind === "fy") {
    const fyStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    return [`${fyStart}-04-01`, todayIso()];
  }
  return ["", ""];
}

export function prettyDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("en-IN", {
      weekday: "short", day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return iso;
  }
}
